import { CircularProgress } from '@mui/material';
import Container from '@mui/material/Container';

const FullPageLoaderPage: React.FC = () => {
  return (
    <Container
      sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <CircularProgress size={100} />
    </Container>
  );
};

export default FullPageLoaderPage;
